<template lang="pug">
  div#app
    router-view
    action-dialog
    message-dialog
    confirm-dialog
    block-dialog
    hidden-dialog
    helpOTP-dialog
    approval-request-dialog
    security-dialog
    list-modal-dialog
    warning-dialog
    AgentMapDialog
    div#kakao-chat(v-if="!AppState.isApplication && !AppState.isStandalone")
</template>

<script>
import {loadLanguageAsync} from './i18n'
import {ActionDialog,
  MessageDialog,
  ConfirmDialog,
  BlockDialog,
  HiddenDialog,
  HelpOTPDialog,
  ApprovalRequestDialog,
  SecurityDialog,
  ListModalDialog,
  WarningDialog,
  AgentMapDialog,
} from './components/dialogs'

export default {
  name: 'App',
  components: {
    ActionDialog,
    ConfirmDialog,
    BlockDialog,
    HiddenDialog,
    MessageDialog,
    HelpOTPDialog,
    ApprovalRequestDialog,
    SecurityDialog,
    ListModalDialog,
    WarningDialog,
    AgentMapDialog,
  },
  created () {
    this.AppState.$on('language-changed', lang => {
      loadLanguageAsync(lang)
    })
  },
  mounted () {
    if (!process.env.VUE_APP_STANDALONE) {
      /*
			this.$freshchat.setExternalId(1);
			this.$freshchat.open();

			window.fwSettings={
			'widget_id':72000003611
			};
			!function(){if("function"!=typeof window.FreshworksWidget){var n=function(){n.q.push(arguments)};n.q=[],window.FreshworksWidget=n}}()

			let freshCRMScript = document.createElement('script')
			freshCRMScript.setAttribute('src', 'https://widget.freshworks.com/widgets/72000003611.js')
			document.head.appendChild(freshCRMScript)
      */
    }
  }
}
</script>

<style lang="scss">
@import '~vue-awesome-notifications/dist/styles/style.scss';
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;400;500;700;900&display=swap');

@font-face {
  font-family: 'Noto Sans KR';
  src: url('./assets/fonts/NotoSansKR-Regular.ttf') format('truetype'); /* ttf 파일 경로 */
  font-weight: 400; /* 해당 폰트의 굵기 설정 */
  font-style: normal; /* 해당 폰트의 스타일 설정 */
}

@font-face {
  font-family: 'Noto Sans KR';
  src: url('./assets/fonts/NotoSansKR-Medium.ttf') format('truetype'); /* ttf 파일 경로 */
  font-weight: 500; /* 해당 폰트의 굵기 설정 */
  font-style: normal; /* 해당 폰트의 스타일 설정 */
}

@font-face {
  font-family: 'Noto Sans KR';
  src: url('./assets/fonts/NotoSansKR-Bold.ttf') format('truetype'); /* ttf 파일 경로 */
  font-weight: 600; /* 해당 폰트의 굵기 설정 */
  font-style: normal; /* 해당 폰트의 스타일 설정 */
}

html, body {
  height: 100%;
}

#kakao-chat {
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: 10;
}

#app {
  font-family: 'Noto Sans KR', 'Malgun Gothic', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 14px;
  color: #000000;
  min-height: 100%;
  position: relative;
  background-color: #FAFAFA;
}

.content {
  padding-top: $content-margin-top;
  padding-bottom: 100px;
}

.plain-button {
  border: 0;
  background-color: transparent;
  cursor: pointer;
  outline: 0;
}
.plain-button:focus {
  outline:0;
}

tbody.lmm-table-body {
  
  td {
    background-color: #FFFFFF !important;
    vertical-align: middle;
    .icon-alive { color: #1D8102 }
    .icon-os { color: #6F6F6F; }
    
  }
  .table-active {
    // opacity: 0.4;
    .alive-online {
      color: #1D8102
    }
    .alive-offline {
      color: #6F6F6F
    }
  }
}

.lmm-content-body-padded {
  position: relative;
  padding: 1rem 1.5rem;

  @media (max-width: 768px) {
    padding: 20px 20px 0px;
  }
}

.table {
  // th { color: #b9b9b9; }
  tr { background-color: #FFFFFF; }
}

.hidden-picker {
  display:inline-block;
  width:1px; height: 1px;
  .input-group > .form-control {
    display: none;
  }
}

.lmm-switch {
  margin-bottom: 0;
  vertical-align: -2px;
}

.fa-icon {
  vertical-align: middle;
}

.vdp-datepicker {
  .form-control {
    font-size: 0.8rem;
    border: 0;
    border-radius: 0;
    cursor: pointer;
    background-color: transparent;
    transition: background-color 300ms;
    &:hover {
      background-color: rgba(0,0,0,0.08);
    }
  }
}

.lmm-common-popup-header {
  padding: 5px 0;
  border-bottom: 0;
  img {
    height: 30px;
  }
}

div.modal {
  z-index: 1074;
}
div.modal-backdrop {
  z-index: 1073;
}

// SWITCH OVERWRITE
#app .vue-switcher-theme--bootstrap.vue-switcher-color--default.vue-switcher--unchecked {
  div { background-color: #e4e4e4; }
  div:after { background-color: #d0d0d0; }
}

#app .vue-switcher-theme--bootstrap.vue-switcher-color--warning.vue-switcher {
  div { background-color: $mainTheme !important; }
  div:after { background-color: $hover; }
}

#app .vue-switcher-theme--bootstrap.vue-switcher-color--success.vue-switcher {
  div { background-color: $mainTheme !important; }
  div:after { background-color: $hover; }
}

#app .btn-secondary {
  color: #6F6F6F;
  border-color: #6F6F6F;
  background-color: #ffffff;
  text-align: center;

  &.active, &:hover {
    color: #000000;
    border-color: #000000;
  }


  &.free-trial-btn {
    color: #fff;
    background-color: #6F6F6F;
    border: 0px;
    transition: background-color 400ms;
    &:hover { background-color: #0073BB; }
  }
}

.btn-no-border {
  color: #6F6F6F;
  border-color: #FFFFFF !important;
  background-color: #ffffff;
  text-align: center;

  &.active, &:hover {
    color: #000000;
    border-color: #000000;
  }
}

.vdp-datepicker {
  background-color: white
}
</style>